import { useOfferStore, } from '@systemeio/digital-store-shared';
import { useEffect, useRef, useState } from 'react';
import { getCalculatePrice } from '../api/get-calculate-price';
import { useWatch } from '@systemeio/util';
export const useCalculatePrice = ({ productId, pricePlan, quantity, offer, country, paymentMethod, taxNumber, }) => {
    const [calculatePrice, setCalculatePrice] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const { setFinalAmount } = useOfferStore();
    useWatch(calculatePrice, calculatePrice => calculatePrice && setFinalAmount(calculatePrice.grossAmount));
    const abortControllerRef = useRef();
    useEffect(() => {
        if (!pricePlan || !country)
            return;
        const getData = async () => {
            abortControllerRef.current = new AbortController();
            setIsLoading(true);
            try {
                const data = await getCalculatePrice({
                    customer: {
                        countryCode: country,
                        paymentMethod: paymentMethod ?? null,
                        taxNumber: taxNumber ?? null,
                    },
                    offer,
                    product: productId,
                    pricePlan: pricePlan.id,
                    quantity,
                }, abortControllerRef.current?.signal);
                !!data.length && setCalculatePrice(data[0]);
            }
            catch (e) {
                setCalculatePrice(undefined);
                console.error(e);
            }
            finally {
                setIsLoading(false);
            }
        };
        if (abortControllerRef.current?.signal) {
            abortControllerRef.current.abort('new_request_sent');
        }
        getData();
    }, [quantity, offer, country, paymentMethod, taxNumber, pricePlan, productId]);
    return {
        calculatePrice,
        isLoading,
    };
};
